<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        xs12
        md12
      >

      

        <v-dialog persistent
          v-model="dialog"
          width="1000"
          hegiht="auto"
        >
          <template v-slot:activator="{ on }">
            
                <v-flex
                  xs12
                  md6
                >
            <v-btn
              color="success"
              dark
              v-on="on"
            >
              Create new
            </v-btn>

            <download-excel 
                  class="v-btn  theme--light success"
                  :data="excel_body"
                  :fields="excel_headers"
                  worksheet = "My Worksheet"
                  name="Winner List.xls">
              </download-excel>
            
                </v-flex>
          </template>

          <v-card>
              <contest-form 
              :Item="item"
              :Field="inputFields"
              :Value="valueObj"
              @emitted="getBackData"
              @closed="closeModal"/>
            

            <v-divider/>
        
          </v-card>

        </v-dialog>
        <material-card
          color="green"
          title="Contest quiz list"
        >

          <v-data-table
            :headers="headers"
            :items="contestList"
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="subheading font-weight-light text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="{ item }"
            >
              <td> {{ item.question }}</td>
              <td>{{ item.contest_date }}</td>
              <td>{{ item.prize_amount }} BDT</td>
              <td>
                <v-btn color="success" @click="goDetailsPage(item.id)" small>details</v-btn>
              </td>
            </template>
          </v-data-table>
        </material-card>

            <v-snackbar
              :color="color"
              :bottom="bottom"
              :top="top"
              :left="left"
              :right="right"
              v-model="snackbar"
              dark
            >
              <v-icon
                color="white"
                class="mr-3"
              >
                mdi-bell-plus
              </v-icon>
              <div> {{ noticeMessage }}</div>
              <v-icon
                size="16"
                @click="snackbar = false"
              >
                mdi-close-circle
              </v-icon>
            </v-snackbar>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import Form from '@/views/Form'
export default {
  components: {
    Form
  },
  computed: {
    // ...mapGetters("courses", ["course", "name", "courseList"]),
    ...mapState('dailyQuiz', ['contestList']),
  },
  mounted () {
    this.GetQuizList()
    this.getWinnerExcelData();
  },
  data () {
    return {
    color: null,
    colors: [
      'warning'
    ],
    top: true,
    bottom: false,
    left: false,
    right: false,
    snackbar: false,
    excel_body: [],
    excel_headers : {
          'Contest Date': 'contest_date',
          'Question': 'question',
          'Winner Name': 'name',
          "Winner Phone": "mobile_number"
      },
    headers: [
      {
        sortable: true,
        text: 'Question',
        value: 'question'
      },
      {
        sortable: false,
        text: 'Date',
        value: 'contest_date'
      },
      {
        sortable: false,
        text: 'Prize amount',
        value: 'prize_amount'
      },
      {
        sortable: false,
        text: 'Action',
        value: ''
      }
    ],
      dialog: false,
      noticeMessage: '',
      item: {
        'title': 'New Contest',
        'subTitle': 'Create daily quiz for contest',
        'submitText' : 'Submit'
      },
      valueObj: {},
      inputFields: [
        {
          label: 'Question',
          width: 'md12',
          type: 'text',
          isEnable: true,
          name: 'question',
          formName: 'Question',
          nameRules: [
            v => !!v || 'Question is required'
          ]
        },
        {
          label: 'Option 1',
          width: 'md6',
          type: 'text',
          isEnable: true,
          name: 'option1',
          formName: 'Option1',
          nameRules: [
            v => !!v || 'Option 1 is required'
          ]
        },
        {
          label: 'Option 2',
          width: 'md6',
          type: 'text',
          isEnable: true,
          name: 'option2',
          formName: 'Option 2',
          nameRules: [
            v => !!v || 'Option 2 is required'
          ]
        },
        {
          label: 'Option 3',
          width: 'md6',
          type: 'text',
          isEnable: true,
          name: 'option3',
          formName: 'Option 3',
          nameRules: [
            v => !!v || 'Option 3 is required'
          ]
        },
        {
          label: 'Option 4',
          width: 'md6',
          type: 'text',
          isEnable: true,
          name: 'option4',
          formName: 'Option 4',
          nameRules: [
            v => !!v || 'Option 4 is required'
          ]
        }
       
      ]
    }
  },
  created () {
  },
  methods: {
    ...mapActions("dailyQuiz", ["GetQuizList","getContestQuizWinnerList"]),
    goDetailsPage (id) {
      this.$router.push('/daily-quiz-details/' + id)
    },
    getBackData (data) {
          this.color = data.status === "OK" ? "success": "warning"
          if (data.status === "OK") {
            this.noticeMessage = "Success! " + data.messages;
            this.dialog = false
          } else {
            this.noticeMessage = "Warning! " + data.messages;
          }
          this.snack("top");
    },
    async getWinnerExcelData () {
      let data = []
      const response = await this.getContestQuizWinnerList()
      // response.forEach(element => {       
      //     data.push({
      //       'contest_date': element.contest_date ? element.contest_date : null,
      //       'question':  element.question ? element.question : null,
      //       'name': element.name ? element.name : null,
      //       'mobile_number':  element.mobile_number ? element.mobile_number : null            
      //     }) 

      // });
      this.excel_body = response
    },

    closeModal () {
      this.dialog = false
    },
    snack (...args) {
      this.top = false
      this.bottom = false
      this.left = false
      this.right = false

      for (const loc of args) {
        this[loc] = true
      }

      // this.color = this.colors[Math.floor(Math.random() * this.colors.length)]

      this.snackbar = true
    }
  }
}
</script>
